import React, {Component} from "react";  import config from 'react-global-configuration';
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import $ from "jquery";
import jwt_decode from "jwt-decode";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class PendingTasks extends Component{
    constructor(props) {
        super(props);
        this.state = {

            loading:false,

        };

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.showPendingTasks()
    }
    showPendingTasks(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if ($.fn.DataTable.isDataTable('#pTasksTable')) {
            $('#pTasksTable').DataTable().destroy();
        }

        // $('#RequestTable').html('');
        var req = $('#pTasksTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": false,
                "lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/anycardemi/pending-tasks?email="+decoded.email,
                    type: 'GET',
                    dataSrc:function ( json ) {
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                columns: [
                    {"data":"ticket_no"},
                    {"data":"call_id"},
                    {"data":"merchant_name"},
                    {"data":"pincode"},
                    {"data":"city"},
                    {"data":"state"},
                    {"data":"base_tid"},
                    {"data":"ticket_status"},
                    {"data":"assigned_to"},
                    {"data":"utid"},
                ],

            });
    }


    render() {
        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="">
                            <div className="">
                                <div className="header"><h4 className="titleAnyCart nomargin">Pending Tickets</h4><p
                                    className="categoryEmi">Please find your pending Tasks</p></div>
                                <div className="row">
                                    <div className="ro-sep"></div>
                                </div>
                                <div className="">
                                    <div className="content-tdetails-table table-full-width table-responsive">
                                        <table id="pTasksTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Ticket No.</th>
                                                <th>Call ID.</th>
                                                <th>Merchant Name</th>
                                                <th>PIN</th>
                                                <th>City</th>
                                                <th>State</th>
                                                <th>Base TID</th>
                                                <th>Status</th>
                                                <th>Assignee</th>
                                                <th>UTID's Issued</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>

                                        </table>
                                        <div className="gap_ver"></div>
                                        <div className="col-md-3 pull-right">
                                            {/*<button width="100%" type="button" className="btn btn-secondary">Cancel</button> &nbsp;*/}
                                            {/*<button width="100%" type="button" className="btn btn-primary" onClick={this.createUTID.bind(this)}>Create UTID</button>*/}
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="gap_ver"></div>
                                    </div>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default PendingTasks